import { LOG_ANALYTICS_EVENT } from './analytics.actions.constants';
import { ILogAnalyticsEventAction } from './analytics.actions.interfaces';

export interface ILogAnalyticsEventMeta {
  readonly sessionId: number;
  readonly eventTypeId: number;
}

export const logAnalyticsEventAction = (meta: ILogAnalyticsEventMeta): ILogAnalyticsEventAction => ({
  type: LOG_ANALYTICS_EVENT,
  meta
});
